import React, {useState} from "react";
import useListContext from "../../tools/useListContext";
import {TransactionRepository} from "../../repository/AdminDashboard/transaction-Repository";
import toast from "react-hot-toast";
import {SystemRepository} from "../../repository/AdminDashboard/SystemRepository";
import {useModal} from "../../tools/useModal";
import {showToastByIsSuccess} from "../../tools/tools";

const ConfigContext = React.createContext()

export function ConfigContextProvider({children}) {
    const {
        handleUpdateListState, listState, onDevicePerPageChange, changePage, onSearchBtnClick,
    } = useListContext(getItems)

    const [subscriptionCosts, setSubscriptionCosts] = useState({
        month: "",
        sms: "",
        guest: ""
    })
    const [release, setRelease] = useState({})

    const {closeModal, modalState, openModal} = useModal();


    async function getItems() {
        handleUpdateListState("loading", true)
        const response = await SystemRepository.getdata(listState.searchQuery,
            listState.pageNumber)
        handleUpdateListState("loading", false)
        if (!response.success) {
            toast.error(response.message);
            return;
        }
        handleUpdateListState("list", response.data.garantimanage)
        handleUpdateListState("countAll", response.data.countAll)
        setRelease(response.data.release);
        setSubscriptionCosts({
            guest: response.data.costperguest,
            month: response.data.costpermonth,
            sms: response.data.costperSMSpage
        })


    }

    async function editConfigPrice(data) {
        const response = await SystemRepository.configPrice({
            costpermonth: data.month,
            costperSMS: data.sms,
            costperguest: data.guest,
        });
        if (!response.success) {
            toast.error(response.message, {
                className: "text-12 text-dark-blue-200",
            });
            return;
        }
        toast.success(response.message, {
            className: "text-12 text-dark-blue-200",
        });
        setSubscriptionCosts({
            month: data.month,
            sms: data.sms,
            guest: data.guest,
        })

        closeModal();
    }


    async function addWarranty(count) {
        const token = localStorage.getItem("token");
        const response = await SystemRepository.add(count, token);
        if (!response.success) {
            toast.error(response.message);
            return;
        }
        toast.success(response.message, {
            className: "text-12 text-dark-blue-200",
        });

        closeModal();
    }

    async function deleteCallback() {
        const response = await SystemRepository.delete(modalState.selectedItem.id);

        if (!response.success) {
            toast.error(response.message);
            return;
        }

        await getItems();
        closeModal();
    }

    async function updateApplicationVersion(data) {
        const response = await SystemRepository.updateApplication(data);

        showToastByIsSuccess(response.success, response.message)

        if (response.success) {
            closeModal();

        }
    }

    return (<ConfigContext.Provider value={{
        subscriptionCosts,
        listState,
        closeModal,
        modalState,
        openModal,
        changePage, onSearchBtnClick,
        release,
        deleteCallback,
        editConfigPrice,
        addWarranty,
        updateApplicationVersion
    }}>
        {children}

    </ConfigContext.Provider>)

}


export function useConfigContext() {

    return React.useContext(ConfigContext)
}